import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import FitText from "react-textfit";

import Placeholder from "components/Placeholder";

export const Description = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    fontSize: theme.typography.large.fontSize,
  },
}));

export const StyledPlaceholder = styled(Placeholder)(({ theme }) => ({
  marginBottom: 10,
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    marginBottom: 20,
  },
}));

export const StyledFitText = styled(FitText)(({ theme }) => ({
  maxHeight: 65,
  [theme.breakpoints.up("mobile")]: {
    maxHeight: "auto",
  },
}));
